// extracted by mini-css-extract-plugin
export default {"checkbox":"AgentDetailsForm_checkbox__jVv1P","checkbox2":"AgentDetailsForm_checkbox2__xpjDJ"};